import axios from "axios";
const userToken = localStorage.getItem("userToken");
const rootURL = process.env.REACT_APP_API_URL || "";
let awsID = "AKIA6ODVADTHBUYQM4CS";
let awsSECRET = "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";
let awsBucketName = "aukisscontent";
let PayStackLiveKey = "sk_live_ce52560aa2a3c9b7d3f391d48015230734814c52";
// axiosInstance
const axiosInstance = axios.create({
  baseURL: rootURL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers.common["Authorization"] = `Bearer ${userToken}`;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log("Response Error", error.response);
    // if(error.response.status === 401){
    //     console.log('Authentication Error', error.response.data.message);
    // }

    return Promise.reject(error);
  }
);

export {
  rootURL,
  axiosInstance,
  awsID,
  awsSECRET,
  awsBucketName,
  PayStackLiveKey,
};
